import React, { useContext } from 'react';
import styled from 'styled-components';
import { ThemeContext } from 'context/themeContext';
import { useTranslation } from 'react-i18next';

const ShoppingBagFullIcon = styled.div`
  width: 2.29vw;
  height: 2.29vw;
  margin-right: ${(props) => (props.rtlDirection ? 'unset' : '1.04vw')};
  margin-left: ${(props) => (props.rtlDirection ? '1.04vw' : 'unset')};

  display: flex;
  justify-content: center;
  color: ${(props) => props.theme.textSecondary};
  font-size: 2.3vw;
`;

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100% - 1.3vw);
  height: 5.205vw;
  margin-left: 0.65vw;
  margin-right: 0.65vw;
  box-sizing: border-box;
  border-bottom: 1px solid ${(props) => props.theme.borderBackground};
`;

const StyledDiv = styled.div`
  font-size: 1.145vw;
  font-weight: 500;
  color: ${(props) => props.theme.textSecondary};
`;

const App = (props) => {
  const { theme, rtlDirection } = useContext(ThemeContext);
  const { t } = useTranslation();
  const { partsNumber } = props;
  return (
    <Wrapper theme={theme}>
      <ShoppingBagFullIcon
        className="icon-shopping-bag-full"
        rtlDirection={rtlDirection}
        theme={theme}
      />
      <StyledDiv theme={theme}>
        {t('cart.header.You add') + ' ' + partsNumber + ' ' + t('cart.header.part to your Cart')}
      </StyledDiv>
    </Wrapper>
  );
};

export default App;
